<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="form-group">
            <label for="equipment">Equipment</label>
            <wj-combo-box
                id="equipment"
                name="equipment"
                [(ngModel)]="target.equipment"
                [itemsSource]="equipmentOptions"
                [displayMemberPath]="'display'"
                [selectedValuePath]="'value'"
                required
            ></wj-combo-box>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle1Pads">Axle 1 shoe/pads</label>
                    <input id="axle1Pads" type="text" class="form-control" [(ngModel)]="target.axle1Pads" name="axle1Pads" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle1DrumRotor">Axle 1 drum/rotor</label>
                    <input id="axle1DrumRotor" type="text" class="form-control" [(ngModel)]="target.axle1DrumRotor" name="axle1DrumRotor" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle2Pads">Axle 2 shoe/pads</label>
                    <input id="axle2Pads" type="text" class="form-control" [(ngModel)]="target.axle2Pads" name="axle2Pads" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle2DrumRotor">Axle 2 drum/rotor</label>
                    <input id="axle2DrumRotor" type="text" class="form-control" [(ngModel)]="target.axle2DrumRotor" name="axle2DrumRotor" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle3Pads">Axle 3 shoe/pads</label>
                    <input id="axle3Pads" type="text" class="form-control" [(ngModel)]="target.axle3Pads" name="axle3Pads" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle3DrumRotor">Axle 3 drum/rotor</label>
                    <input id="axle3DrumRotor" type="text" class="form-control" [(ngModel)]="target.axle3DrumRotor" name="axle3DrumRotor" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle4Pads">Axle 4 shoe/pads</label>
                    <input id="axle4Pads" type="text" class="form-control" [(ngModel)]="target.axle4Pads" name="axle4Pads" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="axle4DrumRotor">Axle 4 drum/rotor</label>
                    <input id="axle4DrumRotor" type="text" class="form-control" [(ngModel)]="target.axle4DrumRotor" name="axle4DrumRotor" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
